'use client'

import Logo from '../../../components/ui/logo'
import CMSFormComponent from '../CMSForm'
import Modal from '../Modal'
import { Form as FormType } from '@telesoft/types/payload-types'
import Image from 'next/image'
import React from 'react'
import { ButtonProps } from '../ui/button'

export default function ModalForm({
  cmsForm,
  buttonLabel = 'View Form',
  formTitle,
  buttonProps,
  resourceID,
  formMessage,
}: {
  cmsForm: FormType
  buttonLabel?: string
  buttonProps?: ButtonProps
  formTitle?: string
  resourceID?: string
  formMessage?: string
}) {
  return (
    <Modal label={buttonLabel} buttonProps={buttonProps}>
      <div className="grid bg-black grid-cols-1 xl:grid-cols-2 min-h-[600px] w-full">
        <div className="relative text-center">
          <div className="z-20 hidden xl:block absolute left-10 bottom-10">
            <Logo inverted={true} />
          </div>
          <Image
            src={'/assets/images/telesoft-abstract-27.jpeg'}
            layout="fill"
            alt={`${cmsForm?.title} Form`}
            className="hidden xl:block object-cover object-center opacity-30"
          />
        </div>
        <div className="flex w-full bg-white flex-col justify-center p-10">
          {formMessage && <h2 className="text-2xl font-bold mb-4">{formMessage}</h2>}
          <CMSFormComponent title={formTitle} form={cmsForm} resourceID={resourceID} />
        </div>
      </div>
    </Modal>
  )
}
